/*
 * @Author: pengyong
 * @Date: 2020-11-11 22:13:56
 * @LastEditors: pengyong
 * @LastEditTime: 2020-12-08 20:46:15
 * @Description: 路由定义文件
 * @FilePath: /exhibit/src/router/index.js
 */
import Vue from "vue";
import Router from "vue-router";
import index from "@/views/index";
import map from "@/views/map";
import exhibition from "@/views/exhibition";
import user from "@/views/user";
import role from "@/views/role";
import area from "@/views/area";
import zhanqu from "@/views/area/zhanqu";
import zhantai from "@/views/area/zhantai";
import ztDetail from "@/views/area/zhantaiDetail";
import consult from "@/views/consult";
import relation from "@/views/consult/relation";
import consultPdf from "@/views/consult/pdf";
import rcap from "@/views/consult/rcap";
import about from "@/views/about";
import videoList from "@/views/videoList";
import product from "@/views/product";
import detail from "@/views/product/detail";
import contact from "@/views/contact";
import card from "@/views/card";
import chat from "@/views/chat";
import login from "@/views/login";
import register from "@/views/register";
import forget from "@/views/forget";
import conference from "@/views/conference";
import smallconference from "@/views/conference/small";
import smallAgenda from "@/views/conference/smallAgenda";
import smallGuest from "@/views/conference/smallGuest";
import smallIntroduce from "@/views/conference/smallIntroduce";
import big from "@/views/conference/big";
import bigAgenda from "@/views/conference/bigAgenda";
import bigGuest from "@/views/conference/bigGuest";
import islandZhouShan from "@/views/islandZhouShan"
import islandAgricultural from "@/views/islandAgricultural"
import islandFumao from "@/views/islandFumao"
import chukou2021 from "@/views/chukou2021"
import chukou2022 from "@/views/chukou2022"
import chukouXl2022 from "@/views/chukouXl2022"
import plateformInfo from "@/views/plateformInfo"
import shuzijiaoyu from '@/views/shuzijiaoyu'
import spain from '@/views/spain'
import uzi from '@/views/uzi'
import sppl from '@/views/sppl'
import beltRoad from '@/views/beltRoad'

import mobileLogin from '@/views/mobileLogin'
import mobileExhibition from "@/views/mobile/mobileExhibition";
import choosePavilion from '@/views/mobile/pavilion/choosePavilion';
import mobilezhanquExhibitor from '@/views/mobile/mobilezhanquExhibitor'
import mobilezhanquDetaile from '@/views/mobile/mobilezhanquDetaile'
import mobilezhanqu from '@/views/mobile/mobilezhanqu'
import mobileExhibitors from '@/views/mobile/mobileExhibitors'
import mobileConsult from '@/views/mobile/mobileConsult'
import schedule from '@/views/mobile/schedule'
import mobileZhanlan from '@/views/mobile/mobileZhanlan'
import mobileMeetHall from '@/views/mobile/mobileMeetHall'
import mobileGuest from '@/views/mobile/mobileGuest'
import mobileAboutCompany from '@/views/mobile/mobileAboutCompany'
import mobileVideoList from '@/views/mobile/mobileVideoList'
import mobileAboutProduct from '@/views/mobile/mobileAboutProduct'
import mobileAboutProductDetail from '@/views/mobile/mobileAboutProductDetail'
import mobileContact from '@/views/mobile/mobileContact'
import mobileSearch from '@/views/mobile/mobileSearch'
import mobileSmallconference from '@/views/mobile/mobileSmallconference'
import mobileBigconference from '@/views/mobile/mobileBigconference'
import cardHolder from '@/views/mobile/mobilePersonalCenter/cardHolder'
import home from '@/views/mobile/mobilePersonalCenter/home'
import collection from '@/views/mobile/mobilePersonalCenter/collection'
import myCard from '@/views/mobile/mobilePersonalCenter/myCard'
import passwordModify from '@/views/mobile/mobilePersonalCenter/passwordModify'
import personalInfo from '@/views/mobile/mobilePersonalCenter/personalInfo'
import mobileRegister from '@/views/mobileRegister'
import mobileIslandZhouShan from '@/views/mobile/mobileIslandZhouShan'
import mobileComponent from '@/views/mobile/mobileComponent'
import mobileChat from '@/views/mobileChat'
import mobileplateformInfo from '@/views/mobile/mobileplateformInfo'
import exhibitionView from '@/views/exhibitionView'

Vue.use(Router);
//防止报错：Uncaught (in promise)
const originalPush = Router.prototype.push
const originReplace = Router.prototype.replace
Router.prototype.push = function push(location) { 
  return originalPush.call(this, location).catch(err => err)
}
Router.prototype.replace = function replace(location) { 
  return originReplace.call(this, location).catch(err => err)
}

export default new Router({
    routes: [
        {
            path: "/",
            redirect: "/exhibition",
        },
        {
            path: "/index",
            component: index
        },
        {
            path: "/map", // 平面展图
            component: map
        },
        {
            path: "/role", // 选择身份
            component: role
        },
        {
            path: "/login", // 登录
            component: login
        },
        {
            path: "/register", // 注册
            component: register
        },
        {
            path: "/forget", // 忘记密码
            component: forget
        },
        {
            path: "/exhibition", // 首页
            iframeComponent: exhibition
        },
        {
            path: "/plateformInfo", // 平台介绍
            iframeComponent: plateformInfo
        },
        {
            path: "/mobileplateformInfo", // 移动端平台介绍
            iframeComponent: mobileplateformInfo
        },
        {
            path: "/mobileExhibition", // 首页
            component: mobileExhibition
        },
        {
            path: "/mobileLogin", // 移动端登录
            component: mobileLogin
        },
        {
            path: "/mobileRegister", // 移动端注册
            component: mobileRegister
        },
        {
            path: "/choosePavilion", // 选择展馆
            component: choosePavilion
        },
        {
            path: "/mobilezhanqu", // 展区
            component: mobilezhanqu
        },
        {
            path: "/mobilezhanquExhibitor", //所有展商
            component: mobilezhanquExhibitor
        },
        {
            path: "/mobilezhanquDetaile", // 展商详情
            component: mobilezhanquDetaile
        },
        {
            path: "/mobilezhanquDetaile", // 展商详情
            component: mobilezhanquDetaile
        },
        {
            path: "/mobileExhibitors", // 展会
            component: mobileExhibitors
        },
        {
            path: "/mobileConsult", // 咨询台
            component: mobileConsult
        },
        {
            path: "/mobileZhanlan", // 展览厅
            component: mobileZhanlan
        },
        {
            path: "/mobileMeetHall", // 会议厅
            component: mobileMeetHall
        },
        {
            path: "/schedule", // 日程
            component: schedule
        },
        {
            path: "/mobileGuest", // 日程
            component: mobileGuest
        },
        {
            path: "/mobileIslandZhouShan", // 移动端舟山岛
            component: mobileIslandZhouShan
        },
        {
            path: "/mobilecomponent", // 移动-杭州服务贸易云展馆 & 农业馆（统一模板）
            component: mobileComponent
        },
        {
            path: "/mobileAboutCompany", // 公司简介
            component: mobileAboutCompany
        },
        {
            path: "/mobileVideoList", // 视频列表
            component: mobileVideoList
        },
        {
            path: "/mobileAboutProduct", // 产品介绍
            component: mobileAboutProduct
        },
        {
            path: "/mobileAboutProductDetail", // 产品介绍详情
            component: mobileAboutProductDetail
        },
        {
            path: "/mobileContact", // 联系方式
            component: mobileContact
        },
        {
            path: "/mobileSearch", // 搜索
            component: mobileSearch
        },
        {
            path: "/home", // 移动端个人中心首页
            component: home
        },
        {
            path: "/cardHolder", // 移动端个人中心名片夹
            component: cardHolder
        },
        {
            path: "/collection", // 移动端个人中心收藏夹
            component: collection
        },
        {
            path: "/myCard", // 移动端个人中心我的名片
            component: myCard
        },
        {
            path: "/passwordModify", // 移动端个人中心密码修改
            component: passwordModify
        },
        {
            path: "/personalInfo", // 移动端个人中心个人信息
            component: personalInfo
        },
        {
            path: "/mobileSmallconference", //小会议厅
            component: mobileSmallconference
        },
        {
            path: "/mobileBigconference", //大会议厅
            component: mobileBigconference
        },
        {
            path: "/islandZhouShan", //舟山岛
            iframeComponent: islandZhouShan
        },
        {
            path: "/islandAgricultural", //农业展
            iframeComponent: islandAgricultural
        },
        {
            path: "/exhibitionView", // 3D展会容器页
            iframeComponent: exhibitionView,
            meta: {
                title: '舟展汇'
            }
        },
        {
            path: "/hzFumao", //舟山岛
            iframeComponent: islandFumao
        },
        {
          path: "/chukou2021", // 2021浙江出口网上交易会
          iframeComponent: chukou2021
        },
        {
          path: "/chukou2022", // 2022浙江出口网上交易会
          iframeComponent: chukou2022
        },
        {
            path: "/chukouXl2022", // 2022浙江出口网上交易会(系列站)
            iframeComponent: chukouXl2022
          },
        {
            path: "/shuzijiaoyu", //数字教育展
            iframeComponent: shuzijiaoyu
        },
        {
            path: "/spain", //西班牙展
            iframeComponent: spain
        },
        {
          path: "/uzi", //西班牙展
          iframeComponent: uzi
        },
        {
            path: "/sppl", //食品配料展
            iframeComponent: sppl
        },
        {
            path: '/beltRoad',
            iframeComponent: beltRoad
        },
        {
            path: "/area", // 展区
            component: area,
            children: [
                {
                    path: "zhanqu", // 选择展区
                    component: zhanqu
                },
                // {
                //     path: "zhantai", // 选择展台
                //     component: zhantai
                // },
                {
                    path: "ztDetail", // 展台详情
                    component: ztDetail,
                    children: [
                        {
                            path: "about", //展台简介
                            component: about
                        },
                        {
                            path: "videoList", //视频列表
                            component: videoList
                        },
                        {
                            path: "product", //产品介绍
                            component: product
                        },
                        {
                            path: "contact", //联系方式
                            component: contact
                        },
                        {
                            path: "card", //交换名片
                            component: card
                        },
                        {
                            path: "chat", //在线洽谈
                            component: chat
                        },
                        {
                            path: "detail", //展台详情
                            component: detail
                        }
                    ]
                },
                {
                    path: "conference", // 会议厅
                    component: conference
                },
                {
                    path: "smallconference", //小会议厅
                    component: smallconference,
                    children: [
                        {
                            path: "smallAgenda", //小会议厅-会议议程
                            component: smallAgenda
                        },
                        {
                            path: "smallGuest", //小会议厅-嘉宾介绍
                            component: smallGuest
                        },
                        {
                            path: "smallIntroduce", //小会议厅-企业介绍
                            component: smallIntroduce
                        }
                    ]
                },
                {
                    path: "bigconference", //大会议厅
                    component: big,
                    children: [
                        {
                            path: "bigAgenda", //大会议厅-会议议程
                            component: bigAgenda
                        },
                        {
                            path: "bigGuest", //大会议厅-嘉宾介绍
                            component: bigGuest
                        }
                    ]
                },
                {
                    path: "consult", //咨询台
                    component: consult,
                    children: [
                        {
                            path: "relation", //联系我们
                            component: relation
                        },
                        {
                            path: "rcap", //日程安排
                            component: rcap
                        },
                        {
                            path: "consultPdf", //日程安排-pdf展示
                            component: consultPdf
                        }
                    ]
                }
            ]
        }
    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js